import PropTypes from "prop-types";
import SimpleBarReact from "simplebar-react";
// material
import { alpha, styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import React from "react";
import { useState, forwardRef, useRef, useImperativeHandle } from "react";
// ----------------------------------------------------------------------

const RootStyle = styled("div")({
  flexGrow: 1,
  height: "100%",
  overflow: "hidden",
});

const SimpleBarStyle = styled(SimpleBarReact)(({ theme }) => ({
  maxHeight: "100%",
  "& .simplebar-scrollbar": {
    "&:before": {
      backgroundColor: alpha(theme.palette.grey[600], 0.48),
    },
    "&.simplebar-visible:before": {
      opacity: 1,
    },
  },
  "& .simplebar-track.simplebar-vertical": {
    width: 10,
  },
  "& .simplebar-track.simplebar-horizontal .simplebar-scrollbar": {
    height: 6,
  },
  "& .simplebar-mask": {
    zIndex: "inherit",
  },
}));

// ----------------------------------------------------------------------

const Scrollbar = forwardRef(({ children, sx, ...other }, ref) => {
  const scrollRef = useRef();

  useImperativeHandle(ref, () => ({
    scrollToBottom() {
      // var el = new SimpleBarStyle(document.getElementById("aaww1"));
      // console.log(el);
      setTimeout(() => {
        try {
          scrollRef.current.scrollTo({ top: 50000, behavior: "smooth" });
        } catch (error) {}
      }, 300);
    },
  }));

  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  if (isMobile) {
    return (
      <Box sx={{ overflowX: "auto", ...sx }} {...other}>
        {children}
      </Box>
    );
  }
  return (
    <RootStyle>
      <SimpleBarStyle
        scrollableNodeProps={{ ref: scrollRef }}
        timeout={500}
        clickOnTrack={false}
        sx={sx}
        {...other}
      >
        {children}
      </SimpleBarStyle>
    </RootStyle>
  );
});

Scrollbar.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};
export default Scrollbar;
// export default function Scrollbar({ children, sx, ...other }) {
//   const isMobile =
//     /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
//       navigator.userAgent
//     );

//   if (isMobile) {
//     return (
//       <Box sx={{ overflowX: "auto", ...sx }} {...other}>
//         {children}
//       </Box>
//     );
//   }

//   return (
//     <RootStyle>
//       <SimpleBarStyle timeout={500} clickOnTrack={false} sx={sx} {...other}>
//         {children}
//       </SimpleBarStyle>
//     </RootStyle>
//   );
// }
